import { render, staticRenderFns } from "./login.vue?vue&type=template&id=71555386&"
import script from "./login.ts?vue&type=script&lang=ts&"
export * from "./login.ts?vue&type=script&lang=ts&"
import style0 from "./login.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\admin\\Documents\\baocaodieuhanh\\source\\vnta-qltp-frontend\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71555386')) {
      api.createRecord('71555386', component.options)
    } else {
      api.reload('71555386', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=71555386&", function () {
      api.rerender('71555386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/login/login.vue"
export default component.exports